import { populate } from "populate";

const raw = {
  handleResize: true,
  width: 640,
  height: 960,
  x: 0,
  y: 0,
  list: [
    {
      id: "f8b2373b-43f4-464e-8160-d30e264e7eee",
      type: "Container",
      name: "root",
      nameSpace: "",
      className: "",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "",
      data: ""
    },
    {
      id: "b868c81b-778c-4aa9-9e05-ec5368a334c6",
      type: "Sprite",
      name: "bg",
      nameSpace: "",
      className: "",
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: "None"
      },
      texture: "booster_active",
      parent: "f8b2373b-43f4-464e-8160-d30e264e7eee",
      data: ""
    },
    {
      id: "cb3a207e-6014-40ba-90e6-87ad5f0b279c",
      type: "Sprite",
      name: "iconBg",
      nameSpace: "",
      className: "",
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "booster_joker_bg",
      parent: "f8b2373b-43f4-464e-8160-d30e264e7eee",
      data: ""
    },
    {
      id: "f9f5beac-b6ae-4cfa-919b-a83e34d0ad07",
      type: "Sprite",
      name: "icon",
      nameSpace: "",
      className: "",
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "booster_joker",
      parent: "f8b2373b-43f4-464e-8160-d30e264e7eee",
      data: ""
    },
    {
      id: "134ce517-d0bd-4c61-b772-885b9804ede7",
      type: "Container",
      name: "sparklesContainer",
      nameSpace: "",
      className: "",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "f8b2373b-43f4-464e-8160-d30e264e7eee",
      data: ""
    },
    {
      id: "9f972baa-f223-4963-a4dd-2617bfe2335c",
      type: "Sprite",
      name: "amountBg",
      nameSpace: "",
      className: "",
      x: 65,
      y: 58,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "booster_btn_counter",
      parent: "f8b2373b-43f4-464e-8160-d30e264e7eee",
      data: ""
    },
    {
      id: "35f4ba0a-be58-4772-af6c-f63b9d190417",
      type: "Container",
      name: "checkmarkContainer",
      nameSpace: "",
      className: "",
      x: 47,
      y: 58,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "f8b2373b-43f4-464e-8160-d30e264e7eee",
      data: ""
    },
    {
      id: "3f953dad-76a5-429d-b080-3f7daf17b331",
      type: "Sprite",
      name: "lockBg",
      nameSpace: "",
      className: "",
      x: 0,
      y: 77,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "booster_locked_level",
      parent: "f8b2373b-43f4-464e-8160-d30e264e7eee",
      data: ""
    },
    {
      id: "b20dc542-e5af-4070-b8e8-9b057e7295ae",
      type: "Text",
      name: "amountText",
      nameSpace: "",
      className: "",
      x: 1,
      y: -2,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      text: "4",
      localize: false,
      maxWidth: 75,
      maxHeight: 73,
      maxFontSize: 42,
      icons: [],
      style: {
        fontSize: 47,
        fontWeight: "normal",
        fontFamily: "FrancoisOne",
        fill: "#ffffff",
        stroke: "#bb3e01",
        strokeThickness: 5,
        align: "left",
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: "normal",
        dropShadow: true,
        dropShadowAlpha: 1,
        dropShadowAngle: 1.8,
        dropShadowBlur: 0,
        dropShadowColor: "#bb3e01",
        dropShadowDistance: 3,
        leading: 0,
        lineJoin: "round",
        miterLimit: 10,
        trim: false,
        textBaseline: "alphabetic",
        whiteSpace: "pre",
        fontVariant: "normal",
        letterSpacing: 0
      },
      parent: "9f972baa-f223-4963-a4dd-2617bfe2335c",
      data: ""
    },
    {
      id: "2bcb2c16-cc47-4d19-a89f-1fabfaa6cb30",
      type: "Text",
      name: "levelText",
      nameSpace: "",
      className: "",
      x: 18,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      text: "Level 99",
      localize: false,
      maxWidth: 122,
      maxHeight: 43,
      maxFontSize: 29,
      icons: [],
      style: {
        fontSize: 47,
        fontWeight: "normal",
        fontFamily: "FrancoisOne",
        fill: "#ffffff",
        stroke: "#636363",
        strokeThickness: 5,
        align: "left",
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: "normal",
        dropShadow: true,
        dropShadowAlpha: 1,
        dropShadowAngle: 1.8,
        dropShadowBlur: 0,
        dropShadowColor: "#636363",
        dropShadowDistance: 3,
        leading: 0,
        lineJoin: "round",
        miterLimit: 10,
        trim: false,
        textBaseline: "alphabetic",
        whiteSpace: "pre",
        fontVariant: "normal",
        letterSpacing: 0
      },
      parent: "3f953dad-76a5-429d-b080-3f7daf17b331",
      data: ""
    }
  ]
} as const;

export class LevelPopupBoosterLayout {
  static raw = raw;
  root: GameObject<PIXI.Container>;
  bg: GameObject<PIXI.Sprite>;
  iconBg: GameObject<PIXI.Sprite>;
  icon: GameObject<PIXI.Sprite>;
  sparklesContainer: GameObject<PIXI.Container>;
  amountBg: GameObject<PIXI.Sprite>;
  amountText: GameObject<PIXI.Text>;
  checkmarkContainer: GameObject<PIXI.Container>;
  lockBg: GameObject<PIXI.Sprite>;
  levelText: GameObject<PIXI.Text>;

  constructor() {
    populate(this, raw);
  }
}
